import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const AdditionalRoomIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="m6.946 3.455-.283.275L3.933 1l-.377.377 2.73 2.73-1.351 1.352v2.585h-3.4v-3.89l2.4-2.4-.38-.377L1 3.933v4.644h8V5.509L6.946 3.455ZM5.467 8.044V5.68l1.395-1.396.075-.076 1.53 1.522v2.314h-3Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const AdditionalRoomIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="m6.946 3.455-.283.275L3.933 1l-.377.377 2.73 2.73-1.351 1.352v2.585h-3.4v-3.89l2.4-2.4-.38-.377L1 3.933v4.644h8V5.509L6.946 3.455ZM5.467 8.044V5.68l1.395-1.396.075-.076 1.53 1.522v2.314h-3Z" />
        </SvgIcon>
    );
};
